import React from 'react';
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import Grid from '@mui/material/Grid2';
import Header from 'components/header';
import SideBar from 'components/sidebar';
import CustomThemeProvider from 'config/themes/CustomThemeProvider';
import { isLoggedIn } from 'services/authService';
import { routes } from 'config/index';
import domainData from 'store/domainStore';
import usersStore from 'store/usersStore';
import partnersStore from 'store/partnersStore';
import wineListsStore from 'store/wineListsStore';
import wineStore from 'store/wineStore';
import NotFound from 'pages/notFound';

import classes from './styles';

function PrivateRoute({ component: Component, ...rest }) {
  const token = isLoggedIn();
  const currentSP = domainData.getCurrentSP();
  const currentUser = domainData.getCurrentUser();
  usersStore.initializeUserData(currentUser);
  partnersStore.initializeSpData();
  wineListsStore.initializeWineListData(currentSP);
  wineStore.initializeWineData(currentSP);

  const checkRouteAccess = () => {
    const keysList = Object.keys(routes);
    let routeObj;
    for (let i = 0; i < keysList.length; i += 1) {
      if (routes[keysList[i]].path === rest.path) {
        routeObj = routes[keysList[i]];
        break;
      }
    }

    if (routeObj?.accessRoutes?.includes(token?.usersRole?.name)) {
      return true;
    }
    return false;
  };

  return token ? (
    <Box sx={classes.layout}>
      <CustomThemeProvider>
        <Grid size={{ xs: 12, sm: 12, md: 12 }}>
          <Header {...rest} />
        </Grid>
        <Box sx={classes.main}>
          <SideBar />
          {checkRouteAccess() ? <Component {...rest} /> : <NotFound />}
        </Box>
      </CustomThemeProvider>
    </Box>
  ) : (
    <Navigate to={{ pathname: routes.login.path }} replace />
  );
}

PrivateRoute.propTypes = {
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
};

export default PrivateRoute;
